import styled, { css } from 'styled-components';

import { device } from '@/styles/helpers';

export interface ScCookieProps {
  hide?: boolean;
  largeBottomMargin?: boolean;
}

export const ScCookie = styled.div<ScCookieProps>`
  position: fixed;
  bottom: ${({ largeBottomMargin }) => (largeBottomMargin ? '48px' : '32px')};
  transition: 0.3s;
  left: 0;
  right: 0;
  z-index: 101;
  width: fit-content;
  max-width: 905px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.whiteColor};
  column-gap: 8px;
  font-size: 14px;
  line-height: 1.43;
  color: ${({ theme }) => theme.blackColor};
  box-shadow:
    0px 10px 10px rgba(0, 0, 0, 0.4),
    0px 0px 10px rgba(0, 0, 0, 0.8);
  padding: 16px;
  border-radius: 12px;

  ${({ hide }) =>
    hide &&
    css`
      opacity: 0;
      height: 0;
      padding: 0;
      overflow: hidden;
    `}

  @media (${device.tablet}) {
    top: 80px;
    bottom: auto;
    max-width: 100%;
    margin: 0 8px;
    text-align: center;
    flex-direction: column;
    row-gap: 12px;
    width: auto;
  }
  @media (${device.mobile}) {
    top: 72px;
  }
`;

export const ScLink = styled.span`
  color: ${({ theme }) => theme.secondaryColor};
  text-decoration: underline;
  cursor: pointer;
  font-weight: bold;
  transition: 0.3s;

  &:hover {
    color: ${({ theme }) => theme.secondaryColorHover} !important;
  }
`;
